var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_313_4100)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4175 47.9999L20.2601 40.973C19.2249 34.6882 14.299 29.7623 8.01418 28.7271L0.987305 27.5697L8.01418 26.4122C14.299 25.377 19.2249 20.4511 20.2601 14.1663L21.4175 7.1394L22.5749 14.1663C23.6102 20.4511 28.536 25.377 34.8209 26.4122L41.8478 27.5697L34.8209 28.7271C28.536 29.7623 23.6102 34.6882 22.5749 40.973L21.4175 47.9999Z",
    fill: "url(#paint0_linear_313_4100)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7927 20.4298L37.214 16.9164C36.6964 13.7739 34.2334 11.311 31.091 10.7934L27.5776 10.2147L31.091 9.63592C34.2334 9.11831 36.6964 6.65537 37.214 3.51294L37.7927 -0.000488281L38.3714 3.51294C38.889 6.65537 41.352 9.11831 44.4944 9.63592L48.0078 10.2147L44.4944 10.7934C41.352 11.311 38.889 13.7739 38.3714 16.9164L37.7927 20.4298Z",
    fill: "url(#paint1_linear_313_4100)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_313_4100",
    x1: 41.8478,
    y1: 27.5697,
    x2: 0.987309,
    y2: 27.5573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9276FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#652FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_313_4100",
    x1: 48.0078,
    y1: 10.2147,
    x2: 27.5776,
    y2: 10.2085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9276FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#652FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_313_4100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEmoji);
export default __webpack_public_path__ + "static/media/ai-emoji.d5cc4b09d522a822e729974ba33ed989.svg";
export { ForwardRef as ReactComponent };